import Vue from 'vue'
import Vuex from 'vuex'

import {auth} from './auth.module';

Vue.use(Vuex);

export default new Vuex.Store({
    state: auth.state,
    mutations: {
        SET_BAR_IMAGE (state:any, payload:any) {
            state.barImage = payload
        },
        SET_DRAWER (state:any, payload:any) {
            state.drawer = payload
        },
        SET_SCRIM (state:any, payload:any) {
            state.barColor = payload
        },
    },
    actions: auth.actions,
    modules: {
        auth
    },
    getters: auth.getters,
})
